import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase/config';
import { useUser } from '../Context/UserContext';
import { FiBox, FiGrid, FiShoppingCart, FiTruck, FiTag, FiEdit, FiFileText, FiLogOut, FiUsers } from 'react-icons/fi';
import { PERMISSIONS } from '../Utils/permissions';
import './Admin.css';

export default function AdminSidebar() {
  const navigate = useNavigate();
  const { permissions } = useUser();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/admin/login');
    } catch (error) {
      console.error("Error logging out: ", error);
    }
  };

  return (
    <aside className="admin-sidebar">
      <div className="sidebar-header">
        <div className="sidebar-logo">
            <img src="/assets/images/logo.png" alt="VetCare" style={{height: '30px', filter: 'brightness(0) invert(1)'}} />
            <span>VetCare Admin</span>
        </div>
      </div>
      
      <nav className="sidebar-nav">
        <div className="nav-group">
          <span className="nav-label">Store Management</span>
          {permissions?.[PERMISSIONS.PRODUCTS_MANAGE] && (
            <NavLink to="/admin/products" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
              <FiBox />
              <span>Products</span>
            </NavLink>
          )}
          {permissions?.[PERMISSIONS.CATEGORIES_MANAGE] && (
            <NavLink to="/admin/manage-categories" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
              <FiGrid />
              <span>Categories</span>
            </NavLink>
          )}
          {permissions?.[PERMISSIONS.USERS_MANAGE] && (
            <NavLink to="/admin/users" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
              <FiUsers />
              <span>Manage Users</span>
            </NavLink>
          )}
          {permissions?.[PERMISSIONS.ORDERS_VIEW] && (
            <NavLink to="/admin/orders" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
              <FiShoppingCart />
              <span>Orders</span>
            </NavLink>
          )}
          {permissions?.[PERMISSIONS.DELIVERY_VIEW] && (
            <NavLink to="/admin/delivery" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
              <FiTruck />
              <span>Delivery</span>
            </NavLink>
          )}
          {permissions?.[PERMISSIONS.SHIPPING_RATES_MANAGE] && (
            <NavLink to="/admin/shipping" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
              <FiTag />
              <span>Shipping Rates</span>
            </NavLink>
          )}
          {permissions?.[PERMISSIONS.DISCOUNTS_MANAGE] && (
            <NavLink to="/admin/discounts" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
              <FiTag />
              <span>Discounts</span>
            </NavLink>
          )}

          {permissions?.[PERMISSIONS.AUDIT_LOGS_VIEW] && (
            <NavLink to="/admin/audit-logs" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
              <FiFileText />
              <span>Audit Logs</span>
            </NavLink>
          )}
        </div>

        {(permissions?.[PERMISSIONS.APPEARANCE_MANAGE] || permissions?.[PERMISSIONS.PAGES_MANAGE]) && (
          <div className="nav-group">
            <span className="nav-label">Online Store</span>
            {permissions?.[PERMISSIONS.APPEARANCE_MANAGE] && (
              <NavLink to="/admin/appearance" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                <FiEdit />
                <span>Appearance</span>
              </NavLink>
            )}
            {permissions?.[PERMISSIONS.PAGES_MANAGE] && (
              <NavLink to="/admin/pages" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`} onClick={(e) => e.preventDefault()}>
                <FiFileText />
                <span>Pages</span>
              </NavLink>
            )}
          </div>
        )}

        <div className="nav-group bottom-group">
          <NavLink 
            to="#" 
            onClick={handleLogout}
            className="logout-link"
          >
            <FiLogOut />
            <span>Logout</span>
          </NavLink>
        </div>
      </nav>
    </aside>
  );
}
